/**
 * clients-status-response.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { validateAs, validateFor } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

export type ServerState = "VERSION_NEGOTIATION" | "UNAUTHENTICATED" |
    "DISCONNECTED" | "DISCONNECTING" | "AUTHENTICATED" | "PASSWORD_RESET" |
    "SET_NEW_CREDENTIALS" | "ALGORITHM_RUNNING";

const SERVER_STATES : ServerState[] = [
    "VERSION_NEGOTIATION",
    "UNAUTHENTICATED",
    "DISCONNECTED",
    "DISCONNECTING",
    "AUTHENTICATED",
    "PASSWORD_RESET",
    "SET_NEW_CREDENTIALS",
    "ALGORITHM_RUNNING"
];

/**
 * Information about the current status of one of a channel's aggregations
 */
interface AggregationDescriptor
{
    started : number;
    paused : boolean;
    pausedTimeMillis : number;
    displayName : string;
    running : boolean;
    approximateCount : number;
    filter : any; // not gonna bother typing this for now due to complexity
}

/**
 * Basic information about a channel's connection, regardless of auth status
 */
export interface ChannelDetails
{
    client : string;
    zone : string;
    zoneTitle : string;
    connectedSince : number;
    lastRequestTime : number;
    state : ServerState;
}

export interface FullChannelDetails extends ChannelDetails
{
    channelId : string;
}

/**
 * Additional information available for authenticated channels, including their
 * user, current algorithm, and aggregator details.
 */
export interface AuthenticatedChannelDetails extends ChannelDetails
{
    user : string;
    userName : string;
    adminChannel : boolean;
    algorithm : string;
}

export interface FullAuthenticatedChannelDetails
extends AuthenticatedChannelDetails, FullChannelDetails
{
    agentId : string;
    aggregations : AggregationDescriptor[];
}

/**
 * The {@link ClientsStatusResponse} provides a summary of all of the server's
 * current client connections, and the state and authentication details of each.
 */
@validateFor(MessageTag.RSP_STATUS_CLIENTS)
export class ClientsStatusResponse extends IncomingMessage
{
    public tag : MessageTag = MessageTag.RSP_STATUS_CLIENTS;

    @validateAs({array: "object"}) // TODO: better validation
    public unauthenticated : FullChannelDetails[];
    @validateAs({array: "object"}) // TODO: better validation
    public authenticated : FullAuthenticatedChannelDetails[];
    @validateAs("string")
    public currentIpAddress : string;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/clients-status-response.ts